export default __webpack_public_path__ + "static/media/undraw_profile.28817a9a.svg";